module.exports = __webpack_public_path__ + "img/box_pro_three_4.fec2f672.jpg";